export default __webpack_public_path__ + "static/media/onesignal.43e4c5b8.svg";